export const GlobalSystemParametersNames = {
    AllowCashForSameCCYDeal: "AllowCashForSameCCYDeal",
    AllowCreateBeneficiaryUser:'AllowCreateBeneficiaryUser',
    AllowSwapDealsInTraderBlotter: "AllowSwapDealsInTraderBlotter",
    AmountFormat: "AmountFormat",
    B2BTab: "B2BTab",
    B2BDrawdownAutoUpdate: "B2BDrawdownAutoUpdate",
    BaseCurrency: "BaseCurrency",
    BaseCurrencyName: "BaseCurrencyName",
    BeneficiaryHandlingMethodBackend: 'BeneficiaryHandlingMethodBackend',
    BNSystemDate: "BNSystemDate",
    BNLastClosingDate: "BNLastClosingDate",
    BypassDefault: 'BypassDefault',
    ContactVerificationInterface: 'ContactVerificationInterface',
    ConvenientOpenForwardRate: "ConvenientOpenForwardRate",
    ConveraBatchModelCurrencies: 'ConveraBatchModelCurrencies',
    CreateBeneficiaryFromCustomer: 'CreateBeneficiaryFromCustomer',
    DatabaseBackupPath: "DatabaseBackupPath",
    DatabaseBackupType: "DatabaseBackupType",
    DealCostAmount: "DealCostAmount",
    DealCostCurrency: "DealCostCurrency",
    DefaultBuyCurrencyID: "DefaultBuyCurrencyID",
    DefaultDealFeeStructure: 'DefaultDealFeeStructure',
    DefaultOptionsCoverBank: "DefaultOptionsCoverBank",
    DefaultOutgoingDeliveryMethod: "DefaultOutgoingDeliveryMethod",
    DefaultOutgoingInstrument: "DefaultOutgoingInstrument",
    DefaultPandLRate: "DefaultPandLRate",
    DefaultPaymentInstrument: "DefaultPaymentInstrument",
    DefaultSellCurrencyID: "DefaultSellCurrencyID",
    DeliveryMethodsLinkedToInstrumentLiveDate: "DeliveryMethodsLinkedToInstrumentLiveDate",
    DesktopRateFeed: "DesktopRateFeed",
    EnableButtonBeneficiarySaveInInterface: 'EnableButtonBeneficiarySaveInInterface',
    EnableButtonBeneficiarySaveInOpenPayd: 'EnableButtonBeneficiarySaveInOpenPayd',
    EnableContactVerificationInterface: 'EnableContactVerificationInterface',
    EnablePaymentConfirmationPrompt: "EnablePaymentConfirmationPrompt",
    EnableSavePendingPayments: "EnableSavePendingPayments",
    EnableFundsOnHoldInPaymentScreen:'EnableFundsOnHoldInPaymentScreen',
    EnableButtonBeneficiarySaveInAfex: 'EnableButtonBeneficiarySaveInAfex',
    EnableSTP: "EnableSTP",
    EnforceCreditLimits: 'EnforceCreditLimits',
    ForwardDepositDecimals: 'ForwardDepositDecimals',
    ForwardPointsScale: 'ForwardPointsScale',
	HideCustomerScreenOptions: "HideCustomerScreenOptions",
	HideHolidayOptions: "HideHolidayOptions",
    HolidayTypeNameForCcy: "HolidayTypeNameForCcy",
    HolidayTypeNameForEOD: "HolidayTypeNameForEOD",
    HomeCurrency: "HomeCurrency",
    LastClosingDate: "LastClosingDate",
    MarginCallBreakPeriod: "MarginCallBreakPeriod",
    MarginCallEmails: "MarginCallEmails",
    MarginCallPeriodPercentage: "MarginCallPeriodPercentage",
    MaximumOpenForwardWindow: 'MaximumOpenForwardWindow',
    MaxSpotDays: "MaxSpotDays",
    NoneMaxSpotDays: "NoneMaxSpotDays",
    NostroAccountGuid: 'NostroAccountGuid',
    NotifyWhenEmailHasFailed: "NotifyWhenEmailHasFailed",
    NumberOfDaysForDealAverages: "NumberOfDaysForDealAverages",
    NumberOfDaysForDealSearch: "NumberOfDaysForDealSearch",
    NumberOfDaysToCreateBaseDDForEOD: "NumberOfDaysToCreateBaseDDForEOD",
    NumberOfDaysToCreateNoneBaseDDForEOD: "NumberOfDaysToCreateNoneBaseDDForEOD",
    OnlineDefaultPassword: "OnlineDefaultPassword",
    OnlineQuotesRetrieval: "OnlineQuotesRetrieval",
    OptionsTab: "OptionsTab",
    PercentageFormat: "PercentageFormat",
    PLPositionPeriods:'PLPositionPeriods',
    ProfitRoundingMargin: "ProfitRoundingMargin",
    QuoteRetentionPeriod: "QuoteRetentionPeriod",
    RateExpirationPeriod: "RateExpirationPeriod",
    RateFormat: "RateFormat",
    RateWatchExpirationMonths: "RateWatchExpirationMonths",
    RateWatchExpirationLimitMonths: "RateWatchExpirationLimitMonths",
    RiskScoreNoticeEmail: "RiskScoreNoticeEmail",
    ShowCoverForwardBalances: 'ShowCoverForwardBalances',
    STPLowerLimit: "STPLowerLimit",
    STPUpperLimit: "STPUpperLimit",
    SystemDate: "SystemDate",
    TradeScreenEnableBuyBackDeal: 'TradeScreenEnableBuyBackDeal',
    TradeScreenAllowAdditionalSettlements: 'TradeScreenAllowAdditionalSettlements',
    TradingCustomerContactMandatory: "TradingCustomerContactMandatory",
    VostroConversionDate: "VostroConversionDate",
    WelcomeEmailRecipientSelection: 'WelcomeEmailRecipientSelection',
    WorkSaturday: "WorkSaturday",
    WorkSunday: "WorkSunday",
    DealWarningFullDisbursement: 'DealWarningFullDisbursement',
}